import React, { useState } from "react";
import { RiFileExcel2Fill } from "react-icons/ri";
import PropTypes from "prop-types";
import { uepClient } from "uepClient";
import moment from "moment";
import "./ExcelExport.scss";
import WithAlert from "hoc/WithAlert";
import { Spinner } from "react-bootstrap";
function ExcelExport(props) {
  const {
    className,
    apiUrl,
    excelFileName,
    appendDateToFile,
    showAlert,
  } = props;
  const date = appendDateToFile ? `-${moment().format("DD-MM-YYYY")}` : "";
  const fileName = `${excelFileName}${date}`;
  const [isLoading, setLoading] = useState(false);
  const onExportClick = () => {
    setLoading(true);
    uepClient()
      .get(apiUrl, { responseType: "blob" })
      .then(function (response) {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // IE variant
          window.navigator.msSaveOrOpenBlob(
            new Blob([response.data], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            }),
            fileName
          );
        } else {
          const url = window.URL.createObjectURL(
            new Blob([response.data], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        }
        showAlert({
          variant: "success",
          content: (
            <span>
              <b>Success!</b> Your file has been dowloaded successfully.
            </span>
          ),
        });
      })
      .catch((err) => {
        showAlert({
          variant: "danger",
          content: (
            <span>
              <b>Error!</b> File couldn’t be downloaded. Please try again.
            </span>
          ),
        });
        console.error(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return isLoading ? (
    <Spinner className="excel-spinner" animation="border" />
  ) : (
    <RiFileExcel2Fill
      className={`excel-export ${className}`}
      onClick={onExportClick}
    />
  );
}

ExcelExport.propTypes = {
  className: PropTypes.string,
  apiUrl: PropTypes.string.isRequired,
  excelFileName: PropTypes.string,
  appendDateToFile: PropTypes.bool,
};

ExcelExport.defaultProps = {
  className: "",
  excelFileName: `Excel-${moment().format("DD-MM-YYYY")}`,
  appendDateToFile: true,
};

export default WithAlert(ExcelExport);
